import { ToolLoading } from '@procureai/uix/ai';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '@/legacy/common/types';

export const ChatMessageThinkingPart = () => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'Chat' });
  return <ToolLoading label={t('thinking')} />;
};
